import * as React from "react";
import * as moment from "moment";
import {Link} from "react-router-dom";
import {ProductsEnum, ValuableItem, ValuableItemTypeEnum} from "@falcon/services";

declare global {
    interface Window {
        // Google analytics data layer
        LvDataLayer: any;
    }
}

export class PluginTemplates {

    public static convertDate = (inputDate: string, format: string) => {
        const valueAsMoment = moment(inputDate, moment.ISO_8601);
        if (valueAsMoment.isValid()) {
            return (valueAsMoment.format(format))
        }
        return null;
    };

    public static getOrdinal = (num: number): string => {
        const suffixes = ["th","st","nd","rd"];
        const numberEnding = num % 100;
        return num + (suffixes[(numberEnding - 20) % 10] || suffixes[numberEnding] || suffixes[0]);
    };

    public static convertWolfPaymentDate = (date: string): string => {
        const nextPaymentDate = moment().set("date", parseInt(date, 10));
        return PluginTemplates.getOrdinal(parseInt(moment(nextPaymentDate).format("DD"), 10))
    }

    public static convertDateUTC = (inputDate: string, format: string) => {
        const valueAsMoment = moment.utc(inputDate, moment.ISO_8601);
        if (valueAsMoment.isValid()) {
            return (valueAsMoment.format(format))
        }
        return null;
    };

    public static getSpecifiedItemWordings (item: ValuableItem) {
        let description: string | JSX.Element = <b className="font-weight-semi-bold">Description</b>;
        let serialNumber: string | JSX.Element = <b className="font-weight-semi-bold">Serial number</b>;

        switch (item.valuableItemType) {
            case ValuableItemTypeEnum.BIKE:
                description = <><b className="font-weight-semi-bold">Description</b> (e.g Giant, road bike)</>;
                serialNumber = <><b className="font-weight-semi-bold">Serial number</b> (The majority of serial numbers are located under the bottom bracket where the two pedal cranks meet)</>;
                break;
            case ValuableItemTypeEnum.JEWELLERY:
                description = "(e.g Tiffany necklace / Rolex watch)";
                break;
            case ValuableItemTypeEnum.MOBILE:
                description = <><b className="font-weight-semi-bold">Description</b> (e.g iPhone X, 250GB)</>;
                serialNumber = <><b className="font-weight-semi-bold">IMEI</b> (To see the IMEI of your phone, call the number <b>*#06#</b>)</>;
                break;
            case ValuableItemTypeEnum.CAMERA:
                description = <><b className="font-weight-semi-bold">Description</b> (e.g Nikon DSLR D7500)</>;
                break;
            case ValuableItemTypeEnum.MUSIC:
                description = <><b className="font-weight-semi-bold">Description</b> (e.g Gibson Guitar Les Paul Standard '50s)</>;
                break;
            case ValuableItemTypeEnum.HEARING:
                description = <><b className="font-weight-semi-bold">Description</b> (e.g HD 500 Digital Hearing Aid)</>;
                break;
            case ValuableItemTypeEnum.SPORT:
                description = <><b className="font-weight-semi-bold">Description</b> (e.g Burton Mystery snowboard)</>;
                break;
        }
        return {description, serialNumber};
    }

    public renderBackButton = (link?: string): JSX.Element =>
            link ?
                <Link to={link} className="no-underline">
                    <button type="button" className="btn btn-back plugin">Back</button>
                </Link> :
                <a onClick={this.goBack} className="no-underline">
                    <button type="button" className="btn btn-back plugin">Back</button>
                </a>;

    public renderBackLink(buttonName: string, isTop: boolean, link?: string): JSX.Element {
        if (link) {
            return (
                <div className={`${isTop ? "back-link-top" : "back-link-bottom"}`}>
                    <Link to={link}>
                        <button type="button" role="link" className={`btn btn-back-link`}>{buttonName}</button>
                    </Link>
                </div>
            )
        }

        return (
            <div className={`${isTop ? "back-link-top" : "back-link-bottom"}`}>
                <a onClick={this.goBack}>
                    <button type="button" role="link" className={`btn btn-back-link`}>{buttonName}</button>
                </a>
            </div>
        )
    }

    public renderBackReloadLink(buttonName: string, isTop: boolean, link: string): JSX.Element {
        return (
            <div className={`${isTop ? "back-link-top" : "back-link-bottom"}`}>
                <a href="javascript:void(0)" onClick={this.navigateTo(link)}>
                    <button type="button" className={`btn btn-back-link`}>{buttonName}</button>
                </a>
            </div>
        )
    }

    public renderBackReloadLinkWithAdditionalFunctionality(buttonName: string, isTop: boolean, link: string, additionalFunctionality: any): JSX.Element {
        return (
            <div className={`${isTop ? "back-link-top" : "back-link-bottom"}`}>
                <a href="javascript:void(0)" onClick={additionalFunctionality}>
                    <button type="button" className={`btn btn-back-link`}>{buttonName}</button>
                </a>
            </div>
        )
    }

    public setPageTitle = (pageTitle: string) => {
        document.title = pageTitle;

        window.LvDataLayer = {
            pageTitle
        }
    };


    public static readonly getNewQuoteWording: Partial<Record<ProductsEnum, JSX.Element>> = {
        [ProductsEnum.HOME]: (
            <p className="product-description">
                We know what makes a house a home. Whether you choose Allianz <strong>Bronze</strong> or our Defaqto
                5 Star rated <strong>Silver</strong> or <strong>Gold</strong>, we’ll protect your happy place.
            </p>
        ),
        [ProductsEnum.WOLF_MOTOR]: (
            <p className="product-description">
                Cover the basics with <strong>Allianz Essentials</strong> or choose Defaqto 5 Star rated
                cover: <strong>Allianz Silver</strong> or <strong>Allianz</strong> (our highest level). Trust us to
                keep insurance simple.
            </p>
        ),
    };


    private goBack(event: any) {
        event.target.href = window.history.back();
    }

    private navigateTo(link: string) {
        return () => {
            window.location.href = link;
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/PluginTemplates.tsx